
import { Datagrid, DateField, List, SimpleList, TextField } from 'react-admin';

export const TeamList = () => {
    //@ts-ignore
    const isSmall = false
    return (
        <List>
            {isSmall ? (
                <SimpleList
                    primaryText={(record) => record.name}
                />
            ) : (
                <Datagrid rowClick="show" bulkActionButtons={false} >
                    <TextField source="name" />
                    <TextField source="type" label="Sport" />
                    <DateField source="updated_at" showTime={true} />
                </Datagrid>
            )}
            
        </List>
    );
}
